module.exports = __webpack_public_path__ + "936aaf2176ccd120891d1d98009a24eb.png";